import React from "react";
import MainLayout from "../layouts/MainLayout";
import Hero from "../components/homeComp/Hero";
import About from "../components/homeComp/about";
import Join from "../components/homeComp/join";
import LaunchAnimation from "../components/homeComp/launchAnimation";
import Footer from "../components/homeComp/footer";
import Nav from "../components/homeComp/Navbar";



export default function Home() {
  return (
    <MainLayout>
        <LaunchAnimation /> 
        <Nav />
        <Hero />
        <About />
        <Join />
        <Footer />
    </MainLayout>
  );
}
